import { Pricing } from '@nemuru-eng/js-api-client';

import { LenderEarningFee } from './LenderEarningFee';

type Range = Pricing['ranges'][number];

export class PricingValueObject {
  constructor(public readonly pricing: Pricing) {}

  public rangesByLenderEarningFees(lenderEarningFee: LenderEarningFee): Range[] {
    return this.pricing.ranges.filter((range) =>
      range?.lenderEarningsFees.some(
        (fee: LenderEarningFee) =>
          fee.lenderId === lenderEarningFee.lenderId &&
          fee.pricingNameInLenderContext === lenderEarningFee.pricingNameInLenderContext &&
          fee.pricingVersion === lenderEarningFee.pricingVersion,
      ),
    );
  }

  public uniqueLenderEarningFees(): LenderEarningFee[] {
    let lenderEarningFees = [] as LenderEarningFee[];
    for (const pricingRange of this.pricing.ranges) {
      if (lenderEarningFees.length === 0 && pricingRange.lenderEarningsFees?.length > 0) {
        lenderEarningFees = [...lenderEarningFees, ...pricingRange.lenderEarningsFees];
        continue;
      }
      const newLenderEarningFees = pricingRange.lenderEarningsFees?.filter(
        (lenderEarningFee: LenderEarningFee) =>
          !lenderEarningFees.some(
            (fee: LenderEarningFee) =>
              fee.lenderId === lenderEarningFee.lenderId &&
              fee.pricingNameInLenderContext === lenderEarningFee.pricingNameInLenderContext &&
              fee.pricingVersion === lenderEarningFee.pricingVersion,
          ),
      );
      if (newLenderEarningFees?.length > 0) {
        lenderEarningFees = [...lenderEarningFees, ...newLenderEarningFees];
      }
    }
    return lenderEarningFees.sort((a, b) => (a.lenderId > b.lenderId ? 1 : -1));
  }
}
